var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5007 21.3334C48.5007 24.2789 46.1128 26.6667 43.1673 26.6667C40.2218 26.6667 37.834 24.2789 37.834 21.3334C37.834 18.3879 40.2218 16 43.1673 16C46.1128 16 48.5007 18.3879 48.5007 21.3334Z",
    fill: "url(#paint0_linear_5781_73721)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3476 3.33337H32.6537C38.8093 3.33334 43.6335 3.33332 47.3974 3.83937C51.2501 4.35734 54.2901 5.43825 56.6763 7.82441C59.0625 10.2106 60.1434 13.2506 60.6613 17.1033C61.1674 20.8672 61.1674 25.6913 61.1673 31.847V32.0825C61.1673 37.1726 61.1673 41.3395 60.8909 44.7321C60.6131 48.1415 60.0438 50.9905 58.7697 53.3567C58.2077 54.4003 57.5171 55.3349 56.6763 56.1757C54.2901 58.5618 51.2501 59.6427 47.3974 60.1607C43.6335 60.6668 38.8094 60.6667 32.6536 60.6667H32.3477C26.1919 60.6667 21.3678 60.6668 17.6039 60.1607C13.7512 59.6427 10.7112 58.5618 8.32502 56.1757C6.20961 54.0603 5.11718 51.4273 4.53625 48.1612C3.96558 44.9527 3.86119 40.9609 3.8395 36.004C3.83398 34.7431 3.83398 33.4096 3.83398 32.0027V31.847C3.83395 25.6913 3.83393 20.8672 4.33998 17.1033C4.85795 13.2506 5.93886 10.2106 8.32502 7.82441C10.7112 5.43825 13.7512 4.35734 17.6039 3.83937C21.3678 3.33332 26.192 3.33334 32.3476 3.33337ZM18.1369 7.8037C14.7278 8.26204 12.6725 9.13375 11.1534 10.6528C9.63436 12.1719 8.76265 14.2272 8.30431 17.6362C7.83823 21.1029 7.83399 25.6581 7.83399 32C7.83399 32.7747 7.83399 33.5239 7.8349 34.2494L10.5046 31.9134C12.9346 29.7871 16.5971 29.9091 18.8803 32.1923L30.3196 43.6316C32.1522 45.4642 35.037 45.7141 37.1574 44.2239L37.9526 43.665C41.0039 41.5206 45.1322 41.769 47.9043 44.2639L55.4521 51.057C56.2119 49.4614 56.6631 47.3649 56.9041 44.4073C57.1658 41.1954 57.1673 37.189 57.1673 32C57.1673 25.6581 57.1631 21.1029 56.697 17.6362C56.2387 14.2272 55.3669 12.1719 53.8479 10.6528C52.3288 9.13375 50.2735 8.26204 46.8644 7.8037C43.3978 7.33762 38.8426 7.33338 32.5007 7.33338C26.1587 7.33338 21.6035 7.33762 18.1369 7.8037Z",
    fill: "url(#paint1_linear_5781_73721)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5781_73721",
    x1: 36.2189,
    y1: 3.33337,
    x2: 36.2189,
    y2: 60.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5781_73721",
    x1: 36.2189,
    y1: 3.33337,
    x2: 36.2189,
    y2: 60.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.56cd4ef6f7c652da5364943d8624b8cf.svg";
export { ForwardRef as ReactComponent };